import { cva } from '@/styled-system/css';

export const photoCarouselDotRecipe = cva({
  base: {
    alignItems: 'center',
    backgroundColor: 'icon.transparent.onImpact.neutral-fixed',
    borderRadius: 'shape.ellipse',
    boxShadow: 'none',
    display: 'inline-flex',
    flex: 'none',
    height: 'indicator.sm',
    justifyContent: 'center',
    marginInline: 'tightest',
    transition: {
      _motionReduce: 'none',
      _motionSafe:
        'background-color 250ms ease, height 250ms ease, margin 250ms ease, width 250ms ease',
    },
    width: 'indicator.sm',
  },
  variants: {
    isContinuation: {
      false: {},
      true: {
        height: 'indicator.xs',
        width: 'indicator.xs',
      },
    },
    isHidden: {
      false: {},
      true: {
        height: '0',
        marginInline: '0',
        width: '0',
      },
    },
    selected: {
      false: {},
      true: {
        backgroundColor: 'icon.onImpact.neutral-fixed',
        height: 'indicator.md',
        width: 'indicator.md',
      },
    },
  },
});
